import {
	Button,
	Flex,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Heading,
	Input,
	InputGroup,
	InputRightElement,
	Text,
	useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";

const ResetPassword = () => {
	const toast = useToast({
		position: "bottom-right",
		isClosable: true,
		duration: 3000,
	});

	// extract token from url params
	const { token } = useParams();

	const navigate = useNavigate();

	// console.log(token);

	const [loading, setLoading] = useState(false);

	const [passwords, setPasswords] = useState({
		password: "",
		confirmPassword: "",
	});
	const [passwordError, setPasswordError] = useState("");
	const [showPassword, setShowPassword] = useState(false);

	const [confirmPasswordError, setConfirmPasswordError] = useState("");
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const [passwordsMatched, setPasswordsMatched] = useState(false);

	const handleChange = (e) => {
		setPasswords({ ...passwords, [e.target.name]: e.target.value });
	};

	const validatePasswordStrength = () => {
		// password must contain at least 8 characters and at least one number and one uppercase letter and one lowercase letter in the entire string and can have special characters too

		const passwordRegex =
			/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{8,25}$/;

		// const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
		let isValid = passwordRegex.test(passwords.password);
		if (!isValid) {
			setPasswordError(
				"Password must contain at least 8 characters, one uppercase letter, one lowercase letter and one number"
			);
			return false;
		}
		setPasswordError("");
		return true;
	};

	const handleSubmit = async () => {
		if (passwords.password !== passwords.confirmPassword) {
			setConfirmPasswordError("Passwords do not match");
			toast({
				title: "Passwords do not match",
				status: "error",
			});
			return;
		}
		// TODO: call api to reset password
		const url = `https://3.108.223.159.sslip.io/user/reset-password`;
		const data = {
			password: passwords.password,
			confirmPassword: passwords.confirmPassword,
			token,
		};
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});
			const result = await response.json();
			if (result.message.toLowerCase() === "password updated") {
				toast({
					title: "Password reset successfully",
					description: "Kindly login with your new password",
					status: "success",
				});
				setLoading(false);
				navigate("/login");
			} else {
				if (result.message.toLowerCase() === "invalid token") {
					toast({
						title: "Invalid token, please make a new request",
						status: "error",
					});
					setLoading(false);
					navigate("/forgot-password");
					return;
				}
				toast({
					title: "Password reset failed",
					description: result.message,
					status: "error",
				});
				setLoading(false);
			}
		} catch (err) {
			toast({
				title: "Something went wrong",
				description: err.message,
				status: "error",
			});
			setLoading(false);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (passwords.password.length > 0) {
			validatePasswordStrength();
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [passwords.password]);

	useEffect(() => {
		if (passwords.confirmPassword.length > 0) {
			if (passwords.password !== passwords.confirmPassword) {
				setConfirmPasswordError("Passwords do not match");
				setPasswordsMatched(false);
			} else {
				setConfirmPasswordError("");
				setPasswordsMatched(true);
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [passwords.confirmPassword]);

	return (
		<AuthLayout>
			<Flex
				flexDir="column"
				gap="5"
				my="10"
				borderRadius="10"
				bgColor="white"
				p="10"
				w={["95%", "90%", "60%", "50%"]}
				alignItems="center"
				justifyContent="center">
				<Heading>Reset Password?</Heading>
				<FormControl
					w={["100%", "90%", "80%", "60%"]}
					isRequired
					isInvalid={passwords.password && passwordError}>
					<FormLabel textTransform="capitalize">
						Enter your new password
					</FormLabel>
					<InputGroup>
						<Input
							type={showPassword ? "text" : "password"}
							name={"password"}
							placeholder="Use a strong password"
							isInvalid={passwordError}
							value={passwords.password}
							onChange={handleChange}
						/>
						<InputRightElement width="4.5rem">
							<Button
								h="1.75rem"
								size="sm"
								onClick={() => setShowPassword(!showPassword)}>
								{showPassword ? "Hide" : "Show"}
							</Button>
						</InputRightElement>
					</InputGroup>
					<FormErrorMessage>{passwordError}</FormErrorMessage>
				</FormControl>
				<FormControl
					w={["100%", "90%", "80%", "60%"]}
					isRequired
					isInvalid={passwords.confirmPassword && confirmPasswordError}>
					<FormLabel textTransform="capitalize">
						Confirm your new password
					</FormLabel>
					<InputGroup>
						<Input
							disabled={passwords.password.length === 0}
							type={showConfirmPassword ? "text" : "password"}
							name={"confirmPassword"}
							placeholder="Confirm your password"
							isInvalid={confirmPasswordError}
							value={passwords.confirmPassword}
							onChange={handleChange}
						/>
						<InputRightElement width="4.5rem">
							<Button
								h="1.75rem"
								size="sm"
								disabled={passwords.password.length === 0}
								onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
								{showConfirmPassword ? "Hide" : "Show"}
							</Button>
						</InputRightElement>
					</InputGroup>
					<FormErrorMessage>{confirmPasswordError}</FormErrorMessage>
					{passwordsMatched && (
						<Text mt={2} mb={0} fontSize="14px" color="green.500">
							Passwords match
						</Text>
					)}
				</FormControl>

				<Flex mt="5">
					<Button
						colorScheme="green"
						variant="solid"
						mx="auto"
						isLoading={loading}
						onClick={() => {
							handleSubmit();
						}}
						textTransform="uppercase">
						Submit
					</Button>
				</Flex>
			</Flex>
		</AuthLayout>
	);
};

export default ResetPassword;
